import * as React from "react";
import {ConnectedRouter} from 'react-router-redux'
import {History} from 'history';
import {Redirect, Route, Switch} from "react-router";
import AuthRouter from "./AuthRouter";
import AppRouter from "./AppRouter";
import {connect} from "react-redux";
import {RootState} from "../store/reducer/root/RootState";
import LoadingAppView from "../components/pages/LoadingAppView";
import {ToastContainer} from "react-toastify";
import {Fragment} from "react";
import SelfServiceSignupPage from "../components/signup/SelfServiceSignupPage";
import TaxiClaimPage from "../components/taxiClaim/TaxiClaimPage";


interface ComponentProps {
	/**
	 * History object.
	 */
	history: History;
}

interface ReduxProps {
	/**
	 * Indicates if application is initialized.
	 */
	initialized: boolean;
}

type Props = ComponentProps & ReduxProps;

/**
 * Main router with Redux provider.
 */
class MainRouter extends React.PureComponent<Props, {}> {

	render() {
		// Public forms must not wait for the authenticated /users/me check to fail first.
		const publicPath = ["/signup", "/taxi-submit"].indexOf(this.props.history.location.pathname) !== -1;
		if (this.props.initialized || publicPath)
			return (
				<ConnectedRouter history={this.props.history}>
					<Fragment>
						<ToastContainer autoClose={false} className={"c-toastify"}/>
						<Switch>
							<Route exact path="/signup" component={SelfServiceSignupPage}/>
							{/* The client asked for a path without the word "claim". Nothing links here yet,
								so the old one is not kept alive. */}
							<Route exact path="/taxi-submit" component={TaxiClaimPage}/>
							<Route path="/auth" component={AuthRouter}/>
							<Route path="/app" component={AppRouter}/>
							<Redirect to="/app"/>
						</Switch>
					</Fragment>
				</ConnectedRouter>
			);
		else
			return <LoadingAppView/>;
	}
}

function mapStateToProps(state: RootState) {
	return {
		initialized: state.user.initialized
	}
}

export default connect(mapStateToProps)(MainRouter)
